import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import DateInput from '../Common/DateInput'
import SelectForm from '../Common/SelectForm'
import SelectFormSort from '../Common/SelectFromSort'
import { EDUCATIONS, NUMBER_YEAR_PRACTIVE, NO_3D_DESIGNER, CERTIFICATIONS_DESIGNER_FULL } from '../../data/config'
import UploadListImage from '../Common/UploadListImage'
import MultiSelect from 'react-select'


class Designer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {}
        }
    }

    componentWillMount = () => {
        if (this.props.vendor._id)
            this.getDsDetail(this.props.vendor._id);
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.vendor._id !== nextProps.vendor._id) {
            this.getDsDetail(nextProps.vendor._id);
        }
    }

    getDsDetail = (vendor) => {
        do_action('get_designer_detail', { vendor })
            .then(data => {
                if (data.signal) {
                    this.setState({
                        form: data.data
                    });
                }
            })
            .catch(err => console.log(err));
    }

    changeInput = (property, e) => {
        this.props.updateForm(property, e.target.value);
        let { form } = this.state;
        form[property] = e.target.value;
        this.setState({ form });
    }

    handleChangeSelect = (name, value) => {
        let { form } = this.state
        form[name] = value
        this.setState({ form })
        this.props.updateForm(name, value)
    }

    handleChangeMultiSelect = (e) => {
        let array = e.map(item => {
            return item.value
        })
        array = array.join();
        let { form } = this.state;
        form['certifications_others'] = array;
        this.setState({
            form
        })
        let name = 'certifications_others'
        this.props.updateForm(name, array)
    }

    changeDate(value, key) {
        try {
            let time = value.format('DD/MM/YYYY')
            let { form } = this.state
            form[key] = time
            this.setState({ form })
            this.props.updateForm(key, time)
        } catch (err) {
            console.log(err)
        }
    }

    updateImage = (list_image) => {
        let { form } = this.state
        form.list_image = list_image
        this.setState({ form })
        this.props.updateForm('list_image', list_image)
    }

    handleChange = (e) => {
        var options = e.target.options;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        // this.props.someCallback(value);
    }

    render() {
        let { form } = this.state;

        if (!form._id) return ''

        let list_image = form.list_image ? JSON.parse(form.list_image) : []

        let certifications = form.certifications_others.split(",");

        let options = certifications.map((item, index) => {
            return {
                value: item,
                label: item,
            }
        })

        return (
            <div>
                <p className="tit fontMedium">Excerpt</p>
                <div className="form-group">
                    <textarea value={form.excerpt ? form.excerpt : ''} row={3} onChange={this.changeInput.bind(this, 'excerpt')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Date Of Registration</p>
                <div className="form-group">
                    <DateInput timeInput={form.date_of_regis ? form.date_of_regis : ''} name="date_of_regis" changeDate={this.changeDate.bind(this)} />
                    {/* <input type="text" value={form.date_of_regis ? form.date_of_regis : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'date_of_regis')} /> */}
                </div>
                <p className="tit fontMedium">Name of desginer</p>
                <div className="form-group">
                    <input type="text" value={form.name_of_designer ? form.name_of_designer : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'name_of_designer')} readOnly={true}/>
                </div>

                <p className="tit fontMedium">Nationality</p>
                <SelectForm
                    name="nationality"
                    value={form.nationality ? form.nationality : ''}
                    data={['Singaporean/PR', 'Non-Singaporean/PR']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Education</p>
                <SelectForm
                    name="education"
                    value={form.education ? form.education : ''}
                    data={EDUCATIONS}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">No. of yrs in Practice</p>
                <SelectFormSort
                    name="no_of_yrs_in_practice"
                    value={form.no_of_yrs_in_practice ? form.no_of_yrs_in_practice : ''}
                    data={NUMBER_YEAR_PRACTIVE}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Provides 3D Designs via Software</p>
                <SelectForm
                    name="provides_3d_designs_via_software"
                    value={form.provides_3d_designs_via_software ? form.provides_3d_designs_via_software : ''}
                    data={['Yes', 'No']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">No. of 3D Design changes</p>
                <SelectForm
                    name="no_of_3d_design_changes"
                    value={form.no_of_3d_design_changes ? form.no_of_3d_design_changes : ''}
                    data={NO_3D_DESIGNER}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Willing & Able to Manage Site Projects</p>
                <SelectForm
                    name="willing_manager_site"
                    value={form.willing_manager_site ? form.willing_manager_site : ''}
                    data={['Yes', 'No']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Litigation (Local/PR)</p>
                <div className="form-group">
                    <input type="text" value={form.litigation_local_pr ? form.litigation_local_pr : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'litigation_local_pr')} />
                </div>

                <p className="tit fontMedium">Past Criminal Records</p>
                <SelectForm
                    name="past_criminal_records"
                    value={form.past_criminal_records ? form.past_criminal_records : ''}
                    data={['Yes', 'No', 'Not Declaring']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Pending Police Investigation</p>
                <SelectForm
                    name="pending_police_investigation"
                    value={form.pending_police_investigation ? form.pending_police_investigation : ''}
                    data={['Yes', 'No', 'Not Declaring']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Pending Legal Case Defendant</p>
                <SelectForm
                    name="pending_legal_case_defendant"
                    value={form.pending_legal_case_defendant ? form.pending_legal_case_defendant : ''}
                    data={['Yes', 'No', 'Not Declaring']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">BANKRUPTCY/ WINDING UP (Local/PR)</p>
                <div className="form-group">
                    <input type="text" value={form.bankruptcy_winding_up_local_pr ? form.bankruptcy_winding_up_local_pr : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'bankruptcy_winding_up_local_pr')} />
                </div>
                <p className="tit fontMedium">Project Portfolio</p>
                <div className="form-group">
                    <input type="text" value={form.project_portfolio ? form.project_portfolio : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'project_portfolio')} />
                </div>

                <p className="tit fontMedium">Certifications (Others)</p>
                {/* <SelectForm 
                    name="certifications_others" 
                    value={form.certifications_others ? form.certifications_others : ''} 
                    data={CERTIFICATIONS_DESIGNER} 
                    onChange={this.handleChangeSelect.bind(this)} 
                /> */}
                <MultiSelect
                    value={options}
                    isMulti
                    name="certifications_others"
                    options={CERTIFICATIONS_DESIGNER_FULL}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={this.handleChangeMultiSelect.bind(this)}
                />

                <p className="tit fontMedium">Awards</p>
                <SelectForm
                    name="awards"
                    value={form.awards ? form.awards : ''}
                    data={['IDEA', 'Others']}
                    onChange={this.handleChangeSelect.bind(this)}
                />

                <p className="tit fontMedium">Past Client References</p>
                <div className="form-group">
                    <input type="text" value={form.past_client_references ? form.past_client_references : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'past_client_references')} />
                </div>
                <p className="tit fontMedium">List Image</p>
                <div className="form-group">
                    <UploadListImage
                        image={list_image}
                        updateImage={this.updateImage}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(Designer);